import gql from 'graphql-tag';

export default gql`
  query Notifications($limit: Int, $lastId: ID, $sortOrder: SortOrder) {
    notifications(limit: $limit, lastId: $lastId, sortOrder: $sortOrder) {
      nodes {
        _id
        accountId
        title
        description
        status
        createdAt
      }
      totalCount
    }
  }
`;
